import { ScanPackagesView } from "../scan_packages";
import AppIcons from "../../../icons";
import { DeliveriesListItemView } from "./item";
import { FortumApp } from "../../../fortumApp";
import { ClientAction } from "../../../synchronizer";
import { Template } from "../../../../core/template";
import { splitItemCode, arrayMoveItem } from "../../../helpers";
import { emptyElement } from "../../../../core/helpers/dom";
import DropConfirmModal from "../modals/drop_confirm";
import { ModalResultType } from "../../../../core/modal";

export class DeliveriesListView extends ScanPackagesView {

    app: FortumApp;
    template = Template.lazy('/app/views/package_tracking/list/index.html');
    location = {
        position: null,
        message: null
    }
    geoOptions = {
        enableHighAccuracy: true, 
        maximumAge        : 30000, 
        timeout           : 27000
    };

    // Items that user has scanned
    private deliveryItems = [];

    public afterRender(): PromiseLike<any>
    {
        setTimeout(() => {
            this.codeInput.readOnly = false;
        });

        if ('geolocation' in navigator) {
            navigator.geolocation.watchPosition( (position) => {
                console.log(position);
                if (position.coords.accuracy <= 50) {
                    this.location.position = position;
                    this.location.message = null;
                } else {
                    this.location.position = null;
                    this.location.message = 'Received Geolocation was not accurate enough';
                }
            }, (error) => {
                console.log(error);
                this.location.position = null;
                this.location.message = error.message;
            }, this.geoOptions);
        } else {
            console.log('Geolocation is not available!');
        }

        return super.afterRender();
    }

    public beforeRender(): PromiseLike<any>
    {
        super.beforeRender();
        this.app.header.text = this.app.pgettext('package_tracking', 'Deliveries list'),
        this.app.header.iconClass = AppIcons.PackageTracking_List;

        return this.app.db.Package.where('delivery_user_id').equals(this.app.user.id).toArray().then(items => {
            const promises = [];
            if (items.length > 0) {
                items.forEach(item => {
                    if (item.state == 'in_delivery') {
                        const itemObj = new DeliveriesListItemView(item);
                        this.deliveryItems.push(itemObj);
                        this.renderItem(itemObj);
                    }
                });
            } else {
                this.app.toasts.show(this.pgettext('Message', 'No deliveries found!'), 3000);
            }
            console.log(this.deliveryItems);
        });
    }

    protected onCodeScanned(tag: string)
    {
        this.codeInput.value = '';
        const [prefix, item] = splitItemCode(tag);

        if (prefix === 'TUP') {
            this.dropTransportationUnit(item);
        } else {
            this.dropSinglePackage(item);
        }
    }

    private dropTransportationUnit(code: string) {
        let packages = this.deliveryItems.filter( (p) => {
            return (p.item.tup_id == code);
        });

        if (packages.length == 0) {
            this.app.toasts.show(this.pgettext('Message', 'Scanned transportation unit is not on list or it is empty!'));
            return;
        }

        this.confirmDrop(packages);
    }

    private dropSinglePackage(code: string) {
        let packages = this.deliveryItems.filter( (p) => {
            return (p.item.id == code);
        });

        if (packages.length == 0) {
            this.app.toasts.show(this.pgettext('Message', 'Scanned package is not on list!'));
            return;
        }

        this.confirmDrop(packages);
    }

    private confirmDrop(packages) {
        const messages = [];
        messages.push({
            action: ClientAction.PACKAGE_TRACKING.DROP_PACKAGE,
            data: {
                package_ids: packages.map(itemView => itemView.item.package_id),
                location_data: null
            }
        });

        new DropConfirmModal(packages, this.location).showIn(this.app).then(res => {

            if (res && res.type === ModalResultType.CANCEL) {
                this.codeInput.focus();
                return;
            }

            let data = null;
            if (res != null) {
                data = res.data;
            }

            const promises = messages.map(message => {
                message.data['location_data'] = data;
                return this.app.synchronizer.push(message, false, false);
            });
            
            this.codeInput.focus();
            return Promise.all(promises).then(() => {
                if (promises.length > 0) {
                    this.app.toasts.show(this.pgettext('Message', 'Package(s) dropped successfully'));
                }
            }).then(() => {
                packages.forEach((item) => {
                    // Update local state
                    this.app.db.Package.update(item.item.package_id, {
                        state: 'delivered'
                    }).then( (updated) => {
                        this.removeItem(item);
                    });
                });
            });
        });
    }

    private renderItem(item: DeliveriesListItemView) {
        setTimeout(() => {
            this.app.renderPartialView(item).then(() => {
                item.on('delete', view => this.removeItem(view));
                this.resultRows.push(item);
                this.resultsList.insertAdjacentElement('afterbegin', item.element);
            });
        });
    }

    private removeItem(item: DeliveriesListItemView) {
        Object.keys(this.deliveryItems).some(key => {
            const index = this.deliveryItems.indexOf(item);
            console.log(item);
            if (index >= 0) {
                this.deliveryItems.splice(index, 1);
                const tag = item.item.qr_code;
                return true;
            }
        });
        this.refresh();
    }

    private refresh() {
        emptyElement(this.resultsList);

        this.deliveryItems.forEach(item => {
            this.resultsList.insertAdjacentElement('beforeend', item.element);
            this.deliveryItems.forEach(item => item.render(this.resultsList));
        });
    }

    public onBackButtonClick()
    {
        history.back();
    }
}